import React from "react";
import { Container } from "react-bootstrap";
import maintenanceImg from "../assets/images/under_maintenance.gif";
import "./PageNotFound.css";

const PageNotFound = () => (
  <Container>
    <div className="mb-5 PageNotFound__Container">
      <div className="text-center">
        <img src={maintenanceImg} alt="under_maintenance" width={450} />
      </div>
      <div className="text-center m-auto PageNotFound__Container__Content">
        <h3 className="text-blue font-weight-bold PageNotFound__Container__Content__H3">
          Page not found:
          {" "}
          {window.location.pathname}
        </h3>
        {/* <p>
            <Link to="/">Go home</Link>
          </p> */}
      </div>
    </div>
  </Container>
);

export default PageNotFound;
